import { useEffect, useState, useMemo } from 'react';

// Computes dynamic header height based on window width
export function useResponsiveHeaderHeight() {
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1440
  );

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const headerHeight = useMemo(() => {
    const minWidth = 1024; // lg breakpoint
    const maxWidth = 1440; // 2xl breakpoint
    const minHeight = 33;
    const maxHeight = 48;

    if (windowWidth <= minWidth) {
      return { height: minHeight };
    }
    if (windowWidth >= maxWidth) {
      return { height: maxHeight };
    }

    const widthRange = maxWidth - minWidth;
    const heightRange = maxHeight - minHeight;
    return { height: minHeight + ((windowWidth - minWidth) / widthRange) * heightRange };
  }, [windowWidth]);

  return { headerHeight, windowWidth };
}
